/* PawHaus Co — Theme JS */

(function () {
  'use strict';

  /* ── Scroll reveal ──────────────────────────────────────────────── */
  function initReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const targets = document.querySelectorAll('.ph-reveal');
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -48px 0px' }
    );

    targets.forEach((el) => observer.observe(el));
  }

  /* ── Sticky header ──────────────────────────────────────────────── */
  function initHeader() {
    const header = document.getElementById('ph-header');
    if (!header) return;

    // On all pages except the homepage, header is always opaque
    const isHomepage = document.body.classList.contains('template-index');
    if (!isHomepage) {
      header.classList.add('ph-header--scrolled');
    }

    window.addEventListener('scroll', () => {
      const current = window.scrollY;
      if (current > 40 || !isHomepage) {
        header.classList.add('ph-header--scrolled');
      } else {
        header.classList.remove('ph-header--scrolled');
      }
    }, { passive: true });
  }

  /* ── Mobile menu ────────────────────────────────────────────────── */
  function initMobileMenu() {
    const toggle = document.getElementById('ph-menu-toggle');
    const menu   = document.getElementById('ph-mobile-menu');
    const close  = document.getElementById('ph-menu-close');

    if (!toggle || !menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', () => {
      if (menu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (close) close.addEventListener('click', closeMenu);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });
  }

  /* ── Range list hover preview ───────────────────────────────────── */
  function initRangeHover() {
    const items = document.querySelectorAll('.ph-range__item');
    if (!items.length) return;

    items.forEach((item) => {
      const preview = item.querySelector('.ph-range__preview');
      if (!preview) return;

      item.addEventListener('mousemove', (e) => {
        const x = e.clientX + 32;
        const y = e.clientY - 140;
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const pw = 280;
        const ph = 340;

        preview.style.left = Math.min(x, vw - pw - 16) + 'px';
        preview.style.top  = Math.max(8, Math.min(y, vh - ph - 16)) + 'px';
      });
    });
  }

  /* ── Mobile range carousel ─────────────────────────────────────── */
  function initRangeCarousel() {
    var tracks = document.querySelectorAll('.ph-range__track');
    if (!tracks.length) return;

    // Create lightbox once, shared across all carousel sections
    var lb = document.getElementById('ph-range-lightbox');
    if (!lb) {
      lb = document.createElement('div');
      lb.id = 'ph-range-lightbox';
      lb.className = 'ph-range__lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Product image');
      lb.innerHTML = '<button class="ph-range__lightbox-close" aria-label="Close">&times;</button><img class="ph-range__lightbox-img" src="" alt="Product">';
      document.body.appendChild(lb);

      var lbImg = lb.querySelector('.ph-range__lightbox-img');

      function closeLb() {
        lb.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(function() { lbImg.src = ''; }, 280);
      }

      lb.querySelector('.ph-range__lightbox-close').addEventListener('click', closeLb);
      lb.addEventListener('click', function(e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLb();
      });
    }

    var lbImg = lb.querySelector('.ph-range__lightbox-img');

    tracks.forEach(function(track) {
      var slides = Array.from(track.querySelectorAll('.ph-range__slide'));
      if (!slides.length) return;

      slides[0].classList.add('is-active');

      // Dots
      var section = track.closest('.ph-range');
      var dots = section ? Array.from(section.querySelectorAll('.ph-range__dot')) : [];

      function updateActive() {
        var viewCenter = track.getBoundingClientRect().left + track.offsetWidth / 2;
        var best = null, bestDist = Infinity, bestIndex = 0;
        slides.forEach(function(slide, i) {
          var r = slide.getBoundingClientRect();
          var dist = Math.abs(r.left + r.width / 2 - viewCenter);
          if (dist < bestDist) { bestDist = dist; best = slide; bestIndex = i; }
        });
        slides.forEach(function(s) { s.classList.remove('is-active'); });
        if (best) best.classList.add('is-active');
        dots.forEach(function(d, i) {
          d.classList.toggle('is-active', i === bestIndex);
          d.setAttribute('aria-selected', i === bestIndex ? 'true' : 'false');
        });
      }

      // Dot click → scroll slide into center
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          var slide = slides[i];
          if (!slide) return;
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });

      var raf = false;
      track.addEventListener('scroll', function() {
        if (raf) return;
        raf = true;
        requestAnimationFrame(function() { updateActive(); raf = false; });
      }, { passive: true });

      // Lightbox
      slides.forEach(function(slide) {
        var btn = slide.querySelector('.ph-range__slide-img-btn');
        if (!btn) return;
        btn.addEventListener('click', function() {
          var full = btn.getAttribute('data-full');
          if (!full) return;
          lbImg.src = full;
          lb.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });
      });
    });
  }

  /* ── Cart count live update ─────────────────────────────────────── */
  function updateCartCount() {
    const countEls = document.querySelectorAll('.ph-cart-count');
    if (!countEls.length) return;

    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        countEls.forEach((el) => {
          el.textContent = cart.item_count;
          el.dataset.count = cart.item_count;
        });
      })
      .catch(() => {});
  }

  /* ── Init ───────────────────────────────────────────────────────── */

  /* ── Sticky ATC bar (mobile) ────────────────────────────────────── */
  function initStickyAtc() {
    // Only on product pages
    var productInfo = document.querySelector('product-info, .product');
    if (!productInfo) return;

    var mainAtc = document.querySelector('.product-form__submit, [name="add"]');
    if (!mainAtc) return;

    var productTitle = document.querySelector('.product__title h1, .product__title .h1');
    var priceEl = document.querySelector('.price__regular .price-item--regular, .price-item--regular');

    // Build sticky bar
    var bar = document.createElement('div');
    bar.className = 'ph-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="ph-sticky-atc__info">' +
        '<span class="ph-sticky-atc__name">' + (productTitle ? productTitle.textContent.trim() : '') + '</span>' +
        '<span class="ph-sticky-atc__price">' + (priceEl ? priceEl.textContent.trim() : '') + '</span>' +
      '</div>' +
      '<button class="ph-sticky-atc__btn" type="button">Add to cart</button>';

    document.body.appendChild(bar);

    // Update price when variant changes
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function() {
        var priceNow = document.querySelector('.price__regular .price-item--regular, .price-item--regular');
        if (priceNow) {
          bar.querySelector('.ph-sticky-atc__price').textContent = priceNow.textContent.trim();
        }
      });
    }

    // Click delegates to real ATC
    bar.querySelector('.ph-sticky-atc__btn').addEventListener('click', function() {
      mainAtc.click();
    });

    // Show when ATC button scrolls out of view
    var observer = new IntersectionObserver(function(entries) {
      var atcVisible = entries[0].isIntersecting;
      bar.classList.toggle('is-visible', !atcVisible);
      bar.setAttribute('aria-hidden', atcVisible ? 'true' : 'false');
    }, { threshold: 0.5 });

    observer.observe(mainAtc);
  }

  /* ── Product page trust strip ───────────────────────────────────── */
  function initTrustStrip() {
    // PawHaus 2026-07-22: DISABLED. This JS strip duplicated the canonical Liquid
    // trust strip (snippets/pawhaus-trust-strip.liquid) below the buy button AND
    // carried stale copy ("Free AU shipping over $99", "Ships from Sydney") that
    // contradicts free-shipping-storewide. The Liquid strip is the single source now.
    return;
    var atcWrap = document.querySelector('.product-form__buttons, .product-form');
    if (!atcWrap) return;
    if (document.querySelector('.ph-trust-strip')) return;

    var strip = document.createElement('div');
    strip.className = 'ph-trust-strip';
    strip.innerHTML =
      '<span class="ph-trust-item">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>' +
        'Free AU shipping over $99' +
      '</span>' +
      '<span class="ph-trust-item">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/></svg>' +
        'Ships from Sydney' +
      '</span>' +
      '<span class="ph-trust-item">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20 12V6a2 2 0 00-2-2H6a2 2 0 00-2 2v6m16 0v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6m16 0H4"/></svg>' +
        '7-day change-of-mind returns' +
      '</span>';

    atcWrap.insertAdjacentElement('afterend', strip);
  }


  /* ── Product page image zoom on touch ── */
  function initMobileImageSwipe() {
    var gallery = document.querySelector('.product__media-list');
    if (!gallery || window.innerWidth > 860) return;
    var startX = 0;
    gallery.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    }, {passive: true});
    gallery.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 30) return;
      var items = gallery.querySelectorAll('.product__media-item');
      var active = gallery.querySelector('.product__media-item.is-active');
      if (!active) {
        active = items[0];
        if (!active) return;
      }
      var idx = Array.from(items).indexOf(active);
      var next = dx < 0
        ? items[Math.min(idx + 1, items.length - 1)]
        : items[Math.max(idx - 1, 0)];
      if (next && next !== active) {
        active.classList.remove('is-active');
        next.classList.add('is-active');
        next.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
      }
    }, {passive: true});
  }

  /* ── "Back to top" button ── */
  function initBackToTop() {
    var btn = document.createElement('button');
    btn.className = 'ph-back-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 12V2M2 7l5-5 5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    document.body.appendChild(btn);
    window.addEventListener('scroll', function() {
      btn.classList.toggle('is-visible', window.scrollY > 600);
    }, {passive: true});
    btn.addEventListener('click', function() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    });
  }

  /* ── Product image count indicator on mobile ── */
  function initImageDots() {
    if (window.innerWidth > 860) return;
    var gallery = document.querySelector('.product__media-list');
    if (!gallery) return;
    if (gallery.parentElement.querySelector('.ph-img-dots')) return;

    var dots = document.createElement('div');
    dots.className = 'ph-img-dots';
    gallery.parentElement.appendChild(dots);

    var io = null;
    var current = [];

    // Only the media actually on screen for the selected colour. The colour
    // filter sets inline display:none on the rest, so counting every
    // .product__media-item showed 10 dots against a 5-image gallery.
    function shownItems() {
      return Array.from(gallery.querySelectorAll('.product__media-item')).filter(function (el) {
        return window.getComputedStyle(el).display !== 'none';
      });
    }

    function build() {
      var items = shownItems();
      var same = items.length === current.length && items.every(function (el, i) { return el === current[i]; });
      if (same) return;
      current = items;
      if (io) { io.disconnect(); io = null; }
      dots.innerHTML = '';
      if (items.length < 2) { dots.style.display = 'none'; return; }
      dots.style.display = '';
      items.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'ph-img-dot' + (i === 0 ? ' is-active' : '');
        dots.appendChild(dot);
      });
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = current.indexOf(entry.target);
          if (idx < 0) return;
          var all = dots.querySelectorAll('.ph-img-dot');
          for (var i = 0; i < all.length; i++) {
            all[i].classList.toggle('is-active', i === idx);
          }
        });
      }, { threshold: 0.6, root: gallery });
      items.forEach(function (item) { io.observe(item); });
    }

    build();

    // Rebuild whenever the colour filter re-hides or re-shows media.
    var pending;
    var mo = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(build, 60);
    });
    mo.observe(gallery, { attributes: true, attributeFilter: ['style'], subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initReveal();
    initHeader();
    initMobileMenu();
    initRangeHover();
    initRangeCarousel();
    updateCartCount();
    initStickyAtc();
    initTrustStrip();
    initMobileImageSwipe();
    initBackToTop();
    initImageDots();
  });

})();
